import { render, staticRenderFns } from "./BetslipFooterSingle.vue?vue&type=template&id=5e35c0e4&scoped=true"
import script from "./BetslipFooterSingle.vue?vue&type=script&lang=js"
export * from "./BetslipFooterSingle.vue?vue&type=script&lang=js"
import style0 from "./BetslipFooterSingle.vue?vue&type=style&index=0&id=5e35c0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e35c0e4",
  null
  
)

export default component.exports